<template>
  <div class="tw:flex tw:gap-3 tw:py-2.5 tw:w-full">
    <div class="tw:min-w-[7.5rem] tw:max-w-[7.5rem]">
      <p class="tw:body-2 tw:text-default-700">
        {{ label }}
        <EdroneTooltip
          v-if="tooltip"
          class="tw:inline-block tw:ml-1"
          trigger-event="mouseenter"
          type="normal"
          :helper="tooltip"
        >
          <FontAwesomeIcon icon="fa-light fa-circle-question" />
        </EdroneTooltip>
      </p>
    </div>

    <EdroneSkeletonLoader v-if="isLoading" class="tw:h-[1.25rem] tw:w-full" />

    <template v-else>
      <slot v-if="$slots.default"></slot>
      <p v-else class="tw:body-2 tw:text-black">{{ value ?? "-" }}</p>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EdroneSkeletonLoader from "edrone-components/EdroneSkeletonLoader.vue";
import EdroneTooltip from "edrone-components/EdroneTooltip.vue";

interface Props {
  label: string;
  value?: string | number | null;
  isLoading: boolean;
  tooltip?: string;
}

defineProps<Props>();
</script>
